import { render, staticRenderFns } from "./PromotionBubble.vue?vue&type=template&id=7fe16ecc&scoped=true&"
import script from "./PromotionBubble.vue?vue&type=script&lang=ts&"
export * from "./PromotionBubble.vue?vue&type=script&lang=ts&"
import style0 from "./PromotionBubble.vue?vue&type=style&index=0&id=7fe16ecc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe16ecc",
  null
  
)

export default component.exports